interface ResponseError {
  status: number;
  message: string;
}

function isValidError(arg: ResponseError[]): arg is ResponseError[] {
  for (let i = 0; i < arg.length; i++) {
    if (typeof arg[i].status !== "number" || typeof arg[i].message !== "string") {
      return false;
    }
  }
  return true;
}

function isValidNotification(arg: Notification[]): arg is Notification[] {
  for (let i = 0; i < arg.length; i++) {
    if (typeof arg[i].title !== "string" || typeof arg[i].type !== "string" || typeof arg[i].message !== "string") {
      return false;
    }
  }
  return true;
}

export function isValidResponse(arg: any): arg is HTTPResponse {
  return (
    Array.isArray(arg.data) &&
    Array.isArray(arg.error) &&
    isValidError(arg.error) &&
    Array.isArray(arg.notifications) &&
    isValidNotification(arg.notifications)
  );
}

export interface Notification {
  title: string;
  type: string;
  message: string;
}

export interface HTTPResponse {
  data: Array<any>;
  error: Array<ResponseError>;
  notifications: Array<Notification>;
}
